<template>
  <div class="footer_wrapper">
    <div class="footer">
      ©2024 大鸡排工作室 -
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        粤ICP备2023001473号-2</a
      >
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "Footer",
  mounted() {
    this.PageStatistics();
  },
  watch: {
    '$route': {
      immediate: false,
      handler() {
        this.PageStatistics();
      }
    }
  },
  methods:{
    // 更新页面统计
    PageStatistics() {
      // 获取完整URL
      const page_url = window.location.href;
      api.pageStatistics(page_url).then((res) => {
            
          });
    },
  }
};
</script>

<style scoped>
.footer,
.footer a {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: black;
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue